// Vendor imports
const Immutable = require('immutable')
const PropTypes = require('prop-types')
// Shared imports
const {
  TYPES: modelTypes,
  ARTICLE_SUBTYPES: articleSubtypes
} = require('shared/model-types')
// Common Client V2 imports
const { keyedReviver } = require('client-v2/common/state/record-reviver')

class ArticleModelRecord extends Immutable.Record({
  commentCount: Number(),
  count: Number(),
  description: String(),
  embedUrl: String(),
  hasMix: Boolean(),
  hash: String(),
  hostname: String(),
  image: String(),
  md5image: String(),
  subtype: String(articleSubtypes.TEXT_WITH_IMAGE),
  title: String(),
  type: String(modelTypes.ARTICLE),
  url: String(),
  'url_id': String()
}) {
  // No methods
}

ArticleModelRecord.reviver = keyedReviver(ArticleModelRecord, {
  // No nested data structures
})

ArticleModelRecord.propTypes = {
  commentCount: PropTypes.number,
  count: PropTypes.number,
  description: PropTypes.string,
  embedUrl: PropTypes.string,
  hasMix: PropTypes.bool,
  hash: PropTypes.string,
  hostname: PropTypes.string,
  image: PropTypes.string,
  md5image: PropTypes.string,
  subtype: PropTypes.string,
  title: PropTypes.string,
  type: PropTypes.string,
  url: PropTypes.string,
  'url_id': PropTypes.string
}

module.exports = ArticleModelRecord
